import { render } from "./005-IEBPage.vue?vue&type=template&id=043d3122&scoped=true"
import script from "./005-IEBPage.vue?vue&type=script&lang=js"
export * from "./005-IEBPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=043d3122&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043d3122"]])

export default __exports__